import CheckIcon from '@/components/icons/CheckIcon';
import useItemListImpression from '@/hooks/useItemListImpression';
import Image from '@/components/image';
import CurrencyIcon from '@/components/ui/icons/currency-icon';
import { handlePriceByComma } from '@/helpers/common';

const BundleProductItem = ({ p, selectedItems, toggleItem, index = 0 }) => {
  // The block renders a mobile and a desktop copy of the same list; the
  // impression batcher keys on item id, so only one impression is reported.
  const listRef = useItemListImpression(p, index);

  return (
    <div ref={listRef} key={p?.sku} className='flex items-center p-5'>
      <div
        className={`me-4 flex h-6 w-6 cursor-pointer items-center justify-center rounded-sm ${
          selectedItems.includes(p) || p?.isMain
            ? 'bg-[#1a2650]'
            : 'bg-gray-200'
        }`}
        onClick={() => toggleItem(p, p.isMain)}
      >
        {(selectedItems.includes(p) || p?.isMain) && (
          <CheckIcon size={16} className='text-white' />
        )}
      </div>
      <div className='relative me-4 aspect-square w-16 overflow-hidden rounded border border-gray-100 bg-white'>
        <Image
          width={64}
          height={64}
          src={`${process.env.NEXT_PUBLIC_IMG_BASEURL}/media/catalog/product/${p?.image}`}
          alt={p?.name}
          className='size-full object-contain p-1'
        />
      </div>
      <div className='flex-1'>
        <div className='mb-2 line-clamp-2 text-sm font-medium'>{p?.name}</div>
        <div className='flex flex-col'>
          <div
            className={`mb-1 flex items-center gap-1 text-sm ${
              p?.special_price || p?.discount_amount
                ? 'font-normal text-gray-500 line-through'
                : 'font-medium text-red-600'
            }`}
          >
            {handlePriceByComma(p?.price || 0)}{' '}
            <CurrencyIcon className='size-3' />
          </div>
          {(p?.special_price || p?.discount_amount) && (
            <div className='flex items-center gap-1 text-sm font-medium text-red-600'>
              {handlePriceByComma(
                p?.special_price || p?.price - (p?.discount_amount || 0) || 0
              )}{' '}
              <CurrencyIcon className='size-3' />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BundleProductItem;
